<p-toast></p-toast>
<div *ngIf="!loading">
    <!-- <div *ngIf="response.success!=null && response.success==true"> -->

    <div *ngIf="showForm==true">
        <app-note-doctors [doctorEdit]="true" [save]="false" [othermedical]="false" [localSave]="false">
        </app-note-doctors>
        <div class="ui-g-12">
            <div class="ui-g-4" style="display: table; height: 200px; overflow: hidden;">
                <div style="display: table-cell; vertical-align: middle; text-align:center;"><img
                        [src]="(this.avatar_url==null || (this.avatar_url!=null && this.avatar_url.length==0)) ?'./assets/images/default_profile.jpg':this.avatar_url"
                        style="border-radius: 50%;margin-right:auto;margin-left:auto;" height='160' width='160'></div>
            </div>
            <div class="ui-g-4" style="display: table; height: 200px; overflow: hidden;">
                <div style="display: table-cell; vertical-align: middle; text-align:center;">{{this.label | titlecase}}
                </div>
            </div>
        </div>

        <div class="ui-g-12" *ngIf="!editOthers && !this.loading">
            <app-doctor-login-edit-data [editLoginData]="this.editLoginData"></app-doctor-login-edit-data>
        </div>

        <form accept-charset="UTF-8" #doctorregistrationform="ngForm" (submit)="submitDoctorRegistration()">
            <div class="ui-g-12">
                <div class="card no-margin">
                    <p-fieldset [style]="{'border':'1px solid #000000'}">
                        <p-header><b>Personal Information</b></p-header>
                        <div class="ui-g">
                            <div class="ui-g form-group">
                                <div class="ui-g-12 ui-lg-6">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="firstname">First Name<span
                                                    class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="firstname" type="text" pInputText [pKeyFilter]="name_input"
                                                style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                name="firstname" [(ngModel)]="this.doctorreg.first_name"
                                                #firstname="ngModel" required />
                                            <div *ngIf="!this.doctorreg_boolean.first_name" class="alert alert-danger">
                                                First Name is required.
                                            </div>
                                            <div *ngIf="firstname.invalid && (firstname.dirty || firstname.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.first_name && firstname.errors.required"
                                                    class="invalid">
                                                    First Name is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="middlename">Middle Name</label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="middlename" type="text" pInputText [pKeyFilter]="name_input"
                                                style="width: 260px; color: black; opacity: inherit;"
                                                [(ngModel)]="this.doctorreg.middle_name" name="middlename"
                                                #middlename="ngModel" />
                                            <div *ngIf="middlename.invalid && (middlename.dirty || middlename.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="middlename.errors.FieldValidator" class="invalid">
                                                    Invalid Middle Name.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="lastname">Last Name<span
                                                    class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="lastname" type="text" pInputText [pKeyFilter]="name_input"
                                                style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                name="lastname" [(ngModel)]="this.doctorreg.last_name"
                                                #lastname="ngModel" required />
                                            <div *ngIf="!this.doctorreg_boolean.last_name" class="alert alert-danger">
                                                Last Name is required.
                                            </div>
                                            <div *ngIf="lastname.invalid && (lastname.dirty || lastname.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.last_name && lastname.errors.required"
                                                    class="invalid">
                                                    Last Name is required.
                                                </div>
                                                <!-- <div *ngIf="lastname.errors.FieldValidator" class="invalid">
                                            Invalid Last name.
                                        </div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <p-fieldset [style]="{'width':'87%'}">
                                            <p-header><b>Gender</b><span class="doctor-form-req">*</span></p-header>
                                            <div class="ui-g">
                                                <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                    <p-radioButton value="male" label="Male"
                                                        [(ngModel)]="this.doctorreg.gender" name="gender"
                                                        #gender="ngModel" required></p-radioButton>
                                                </div>
                                                <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                    <p-radioButton value="female" label="Female"
                                                        [(ngModel)]="this.doctorreg.gender" name="gender"
                                                        #gender="ngModel" required>
                                                    </p-radioButton>
                                                </div>
                                                <div class="ui-g-12 ui-lg-4" style="width:30%">
                                                    <p-radioButton value="other" label="Other"
                                                        [(ngModel)]="this.doctorreg.gender" name="gender"
                                                        #gender="ngModel" required>
                                                    </p-radioButton>
                                                </div>
                                                <div *ngIf="!this.doctorreg_boolean.gender" class="alert alert-danger">
                                                    Gender is required.
                                                </div>
                                                <div *ngIf="gender.invalid && (gender.dirty || gender.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.gender && gender.errors.required"
                                                        class="invalid">
                                                        Gender is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </p-fieldset>
                                    </div>

                                </div>
                                <div class="ui-g-12 ui-lg-6">

                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="date_of_birth">Date Of Birth<span
                                                    class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <p-calendar id="date_of_birth" class="notranslate" FieldValidator="Dob"
                                                [defaultDate]="dateTime" [maxDate]="dateTime" dateFormat="dd/mm/yy"
                                                [inputStyle]="{'width': '230px'}" [monthNavigator]="true"
                                                [yearNavigator]="true" yearRange="1900:3099" [showIcon]="true"
                                                placeholder="dd/mm/yyyy" [(ngModel)]="this.doctorreg.date_of_birth_date"
                                                name="date_of_birth" #date_of_birth="ngModel" required></p-calendar>
                                            <div *ngIf="!this.doctorreg_boolean.date_of_birth"
                                                class="alert alert-danger">
                                                Date Of Birth is required.
                                            </div>
                                            <div *ngIf="date_of_birth.invalid && (date_of_birth.dirty || date_of_birth.touched)"
                                                class="alert alert-danger2">
                                                <div
                                                    *ngIf="this.doctorreg_boolean.date_of_birth && date_of_birth.errors.required">
                                                    Date Of Birth is required.
                                                </div>
                                                <div *ngIf="date_of_birth.errors.FieldValidator">
                                                    Invalid Date Of Birth. User must be at least 18.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container
                                        *ngIf="this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']">
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="language">Language Spoken<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <p-multiSelect id="language" [filter]="true" [options]="languages"
                                                    [(ngModel)]="selected_language" optionLabel="label" name="language"
                                                    placeholder="Select"
                                                    [style]="{'width': '260px','color': 'black' ,'opacity': 'inherit'}"
                                                    #language="ngModel" required></p-multiSelect>
                                                <div *ngIf="!this.doctorreg_boolean.language_id"
                                                    class="alert alert-danger">
                                                    Language is required.
                                                </div>
                                                <div *ngIf="language.invalid && (language.dirty || language.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.language_id && language.errors.required"
                                                        class="invalid">
                                                        Language is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                    <!-- <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="drpDownTimezone">Timezone<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-dropdown id="drpDownTimezone" [options]="timezone" [ngModelOptions]="{standalone: true}" [(ngModel)]="selectedTimezone" optionLabel="label" name="timezone" placeholder="Select" [style]="{'width': '260px','color': 'black' ,'opacity': 'inherit'}"  #timezone="ngModel" required></p-dropdown>
                                        <div *ngIf="timezone.invalid && (timezone.dirty || timezone.touched)" class="alert alert-danger">
                                            <div *ngIf="timezone.errors.required" class="invalid">
                                                Timezone is required.
                                            </div>
                                        </div>
                                    </div>
                                    </div> -->

                                    <ng-container *ngIf="!editOthers">
                                        <div class="ui-g-12">
                                            <p-checkbox [(ngModel)]="this.changePassword" [value]="changePassword"
                                                [binary]="true" #passwordchange="ngModel" name="passwordchange">
                                            </p-checkbox> Change Password
                                        </div>
                                        <div *ngIf="this.changePassword">
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-4">
                                                    <label for="prevpassword">Previous Password<span
                                                            class="doctor-form-req">*</span></label>
                                                </div>
                                                <div class="ui-g-12 ui-lg-8">
                                                    <input id="prevpassword" pInputText placeholder="Previous Password"
                                                        name="prevpassword"
                                                        style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                        [(ngModel)]="doctorreg.prev_password" maxlength="25"
                                                        [type]="isPassword?'password':'text'" #prev_password="ngModel">
                                                </div>
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-4">
                                                    <label for="password1">Password<span
                                                            class="doctor-form-req">*</span></label>
                                                </div>
                                                <div class="ui-g-12 ui-lg-8">
                                                    <input placeholder="Password" pInputText
                                                        style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                        [type]="isPassword?'password':'text'" [(ngModel)]="password"
                                                        FieldValidator=password name="password1" maxlength="25"
                                                        #password1="ngModel">
                                                    <span toggle="#password-field" [ngClass]="{
                                                            'fa fa-fw fa-eye': !isPassword,
                                                            'pi pi-eye-slash': isPassword
                                                          }" style="color:black;margin:auto;padding-left:5px;"
                                                        (click)="changeType()"></span>

                                                    <!-- <span toggle="#password-field" class="fa fa-fw fa-eye field_icon " (click)="changeType()" ></span> -->
                                                </div>

                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-4">
                                                    <label for="confirmpassword">Confirm Password<span
                                                            class="doctor-form-req">*</span></label>
                                                </div>
                                                <div class="ui-g-8 ui-lg-6">
                                                    <input id="confirmpassword" pInputText
                                                        placeholder="Confirm Password" name="password2"
                                                        style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                        [(ngModel)]="confirmPassword" maxlength="25"
                                                        [type]="isPassword?'password':'text'"
                                                        #confirmpassword="ngModel">
                                                </div>
                                                <div class="ui-lg-1">
                                                </div>
                                                <div class="ui-lg-1">
                                                    <div>
                                                        <div>
                                                            <a style="display: inline-block;" (click)="showTips()">
                                                                <i class class="fa fa-fw fa-question-circle"></i>
                                                            </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div>
                                                <div *ngIf="password1.invalid && (password1.dirty || password1.touched)"
                                                    class="alert alert-danger1">
                                                    <!-- <div *ngIf="password1.errors.required" class="invalid"> -->
                                                    Password is required.
                                                    <!-- </div> -->
                                                    <div *ngIf="password1.errors.FieldValidator" class="invalid">
                                                        Password should contain minimum 8 characters, at least 1
                                                        Uppercase, 1 Lowercase , 1 Special Character and 1 number.

                                                    </div>
                                                </div>
                                            </div>
                                            <div *ngIf="password!=confirmPassword" class="alert alert-danger1">
                                                <div class="invalid">
                                                    Password and Confirm Password do not match.
                                                </div>

                                            </div>

                                            <div *ngIf="confirmpassword.invalid && (confirmpassword.dirty || confirmpassword.touched)"
                                                class="alert alert-danger1 invalid">
                                                <!-- <div *ngIf="confirmpassword.errors.required" class="invalid"> -->
                                                Confirm password is required.
                                                <!-- </div> -->

                                            </div>
                                            <div class="justify-content-center text-center" id="div_content357"
                                                *ngIf="tipsshowed">

                                                <div class="alert alert-danger1">
                                                    Password should contain minimum 8 characters, at least 1
                                                    Uppercase, 1 Lowecase , 1 Special Character and 1 number.
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-container
                                        *ngIf="this.currentRoleID==this.available_roles['Admin'] || this.currentRoleID==this.available_roles['SuperAdmin'] || this.currentRoleID==this.available_roles['Other_Medical_Professional_Admin']">
                                        <div class="ui-g-12">
                                            <p-checkbox [(ngModel)]="this.changePhoto" [value]="this.changePhoto"
                                                [binary]="true" #photochange="ngModel" name="photochange"></p-checkbox>
                                            Change Profile Photo
                                        </div>
                                        <div *ngIf="this.changePhoto">
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-fieldset styleClass="sample-photo-fieldset">
                                                        <p-header>
                                                            Sample Profile Photo
                                                        </p-header>
                                                        <img src="./assets/images/samplePhotos/doc001.jpg"
                                                            alt="Sample Photo" class="sample-photo-doctor-registration">
                                                        <img src="./assets/images/samplePhotos/doc002.jpg"
                                                            alt="Sample Photo" class="sample-photo-doctor-registration">
                                                        <div class="ui-g-12"
                                                            style="text-align: center;font-weight: bold;">
                                                            Recommended Image Dimensions
                                                            <p>800 pixels X 850 pixels</p>
                                                        </div>
                                                    </p-fieldset>
                                                </div>
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <label for="photot">Profile Photo<span
                                                            class="doctor-form-req">*</span></label>
                                                    <ng-container
                                                        *ngIf="this.avatar_url!=null && this.avatar_url.length>0">
                                                        <a href="javascript:void(0)" style="cursor:pointer"
                                                            (click)="download(this.avatar_url,'Profile_Photo')">
                                                            Download Profile Photo
                                                        </a>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="this.avatar_url==null ||  this.avatar_url?.length==0">
                                                        No Profile Photo Uploaded
                                                    </ng-container>
                                                </div>
                                                <div class="ui-g-12">
                                                    <p-fileUpload name="photo" id="photo" (onRemove)="onRemovePhoto()"
                                                        (onSelect)="uploadProfileFiles($event.files)"
                                                        styleClass="p-fileUpload-label-fix" [showCancelButton]="false"
                                                        [showUploadButton]="false" [maxFileSize]="5033165"
                                                        multiple="false" [fileLimit]="1" accept="image/*">
                                                    </p-fileUpload>
                                                </div>
                                                <div class="alert alert-danger" role="alert">
                                                    <p class="text-center text-gray-underline"><span
                                                            class="font-weight-bold">Note</span>:
                                                        The
                                                        file type supported for Profile Photo are JPEG,JPG,PNG.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>


                            </div>
                        </div>

                    </p-fieldset>



                    <p-fieldset [style]="{'border':'1px solid #000000'}">
                        <p-header><b>Address</b></p-header>
                        <div class="ui-g">
                            <div class="ui-g form-group">
                                <div class="ui-g-12 ui-lg-6">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="country">Country<span class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <p-dropdown id="country" [options]="countries" [(ngModel)]="selectedCountry"
                                                optionLabel="country_name" name="country" placeholder="Select"
                                                [style]="{'color': 'black' ,'opacity': 'inherit'}"
                                                (onChange)="changeStates()" #country="ngModel" required></p-dropdown>
                                            <div *ngIf="!this.doctorreg_boolean.country_id" class="alert alert-danger">
                                                Country is required.
                                            </div>
                                            <div *ngIf="country.invalid && (country.dirty || country.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.country_id && country.errors.required"
                                                    class="invalid">
                                                    Country is required.
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="city">City<span class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="city" type="text" pInputText [pKeyFilter]="city_input"
                                                style="width: 260px; border-color: rgb(16, 151, 16);" name="city"
                                                [(ngModel)]="this.doctorreg.city" #city="ngModel" required />
                                            <div *ngIf="!this.doctorreg_boolean.city" class="alert alert-danger">
                                                City is required.
                                            </div>
                                            <div *ngIf="city.invalid && (city.dirty || city.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.city && city.errors.required"
                                                    class="invalid">
                                                    City is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="address1">Address 1<span
                                                    class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="address1" type="text" pInputText [pKeyFilter]="address"
                                                style="width: 260px; border-color: rgb(16, 151, 16);" name="address1"
                                                #address1="ngModel" [(ngModel)]="this.doctorreg.address_line_1"
                                                required />
                                            <div *ngIf="!this.doctorreg_boolean.address_line_1"
                                                class="alert alert-danger">
                                                Address is required.
                                            </div>
                                            <div *ngIf="address1.invalid && (address1.dirty || address1.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.address_line_1 && address1.errors.required"
                                                    class="invalid">
                                                    Address is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-container
                                        *ngIf="this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']">
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="primarycontact">Primary No.<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-4 ui-lg-2">
                                                <input id="primarycontact" type="text" pInputText
                                                    style="width: 55px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    name="primarycontactCode"
                                                    [(ngModel)]="this.selectedPhoneCode_primary" disabled />
                                            </div>
                                            <div class="ui-g-8 ui-lg-6">
                                                <input id="primarycontact" type="text" maxlength=20 pInputText
                                                    [pKeyFilter]="phoneNumber"
                                                    style="width: 174px; border-color: rgb(16, 151, 16);"
                                                    [(ngModel)]="primary_contact_number" name="primaryno"
                                                    #primaryno="ngModel" required />
                                                <div *ngIf="!this.doctorreg_boolean.primary_contact_number"
                                                    class="alert alert-danger">
                                                    Primary Phone is required.
                                                </div>
                                                <div
                                                    *ngIf="primaryno.invalid && (primaryno.dirty || primaryno.touched)">
                                                    <div *ngIf="this.doctorreg_boolean.primary_contact_number && primaryno.errors.required"
                                                        class="invalid">
                                                        Primary Phone is required.
                                                    </div>

                                                </div>
                                                <!-- <div *ngIf="(primaryno.dirty || primaryno.touched)">
                                                    <div class="invalid"
                                                        *ngIf="this.doctorreg_boolean.primary_contact_number && primary_contact_number?.length!=10">
                                                        Phone number should be of 10 digits
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </ng-container>

                                    <!-- <div class="ui-g-12">
                                    <div class="ui-g-12 ui-lg-4">
                                        <label for="drpDownTimezone">Timezone<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-8">
                                        <p-dropdown id="drpDownTimezone" [options]="this.timezone" [ngModelOptions]="{standalone: true}" [(ngModel)]="this.selectedTimezone" optionLabel="label" name="timezone" placeholder="Select" [style]="{'width': '260px','color': 'black' ,'opacity': 'inherit'}"  #timezone="ngModel" required></p-dropdown>
                                        <div *ngIf="timezone.invalid && (timezone.dirty || timezone.touched)" class="alert alert-danger">
                                            <div *ngIf="timezone.errors.required" class="invalid">
                                                Timezone is required.
                                            </div>
                                            <div *ngIf="country.errors.FieldValidator">

                                            </div>
                                        </div>
                                    </div>
                                    </div> -->


                                </div>
                                <div class="ui-g-12 ui-lg-6">
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="state">State<span class="doctor-form-req">*</span></label>
                                        </div>
                                        <ng-container>
                                            <div class="ui-g-12 ui-lg-8">
                                                <p-dropdown id="state" [options]="states" [(ngModel)]="selectedState"
                                                    optionLabel="state_name" placeholder="Select" name="state"
                                                    #state="ngModel" required></p-dropdown>
                                                <div *ngIf="!this.doctorreg_boolean.state_name"
                                                    class="alert alert-danger">
                                                    State is required.
                                                </div>
                                                <div *ngIf="state.invalid && (state.dirty || state.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.state_name && state.errors.required"
                                                        class="invalid">
                                                        State is required.
                                                    </div>

                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="zip">Zip/Pin Code<span class="doctor-form-req">*</span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="zip" type="text" pInputText [pKeyFilter]="zipCode"
                                                style="width: 260px; border-color: rgb(16, 151, 16);" name="zip"
                                                [(ngModel)]="this.doctorreg.zip_code" #zip="ngModel" required />
                                            <div *ngIf="!this.doctorreg_boolean.zip_code" class="alert alert-danger">
                                                Zip/Pin Code is required.
                                            </div>
                                            <div *ngIf="zip.invalid && (zip.dirty || zip.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.zip_code && zip.errors.required"
                                                    class="invalid">
                                                    Zip/Pin Code is required.
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="ui-g-12">
                                        <div class="ui-g-12 ui-lg-4">
                                            <label for="address_line_2">Address 2<span
                                                    class="doctor-form-req"></span></label>
                                        </div>
                                        <div class="ui-g-12 ui-lg-8">
                                            <input id="address_line_2" type="text" pInputText [pKeyFilter]="address"
                                                style="width: 260px;" name="address_line_2"
                                                [(ngModel)]="this.doctorreg.address_line_2" />
                                        </div>
                                    </div>
                                    <ng-container
                                        *ngIf="this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']">
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="secondarycontact">Secondary No.</label>
                                            </div>
                                            <div class="ui-g-4 ui-lg-2">
                                                <input id="secondarycontact" type="text" pInputText
                                                    style="width: 55px; color: black; opacity: inherit;"
                                                    name="selected_secondary" #selected_secondary="ngModel"
                                                    [(ngModel)]="this.selectedPhoneCode_secondary" disabled />
                                            </div>
                                            <div class="ui-g-8 ui-lg-6">
                                                <input id="secondaryno" type="text" maxlength=20 pInputText
                                                    [pKeyFilter]="phoneNumber" style="width: 174px;"
                                                    [(ngModel)]="secondary_contact_number" name="secondaryno"
                                                    #secondaryno="ngModel" />
                                                <!-- <div
                                                    *ngIf="(secondaryno.dirty || secondaryno.touched) && secondary_contact_number?.length>0">

                                                    <div class="invalid" *ngIf="secondary_contact_number?.length!=10">
                                                        Phone number should be of 10 digits
                                                    </div>
                                                </div> -->
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </p-fieldset>

                    <ng-container
                        *ngIf="this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']">
                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                            <p-header><b>Profile</b></p-header>
                            <div class="ui-g">
                                <div class="ui-g form-group">
                                    <div class="ui-g-12 ui-lg-6">

                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="speciality">Primary Speciality<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <p-dropdown id="speciality" [options]="specialities"
                                                    optionLabel="specialty_name" name="speciality" [filter]="true"
                                                    [(ngModel)]="seletedPrimarySpeciality"
                                                    (ngModelChange)="onSpecialityChange()" placeholder="Select"
                                                    #speciality="ngModel" required></p-dropdown>
                                                <div *ngIf="!this.doctorreg_boolean.primary_speciality_id"
                                                    class="alert alert-danger">
                                                    Primary Speciality is required.
                                                </div>
                                                <div *ngIf="speciality.invalid && (speciality.dirty || speciality.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.primary_speciality_id && speciality.errors.required"
                                                        class="invalid">
                                                        Primary Speciality is required.
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="sspeciality">Secondary Speciality</label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <p-multiSelect id="sspeciality" [options]="sec_specialities"
                                                    [style]="{'width': '230px'}" name="sspeciality"
                                                    [(ngModel)]="selectedSecondarySpeciality"
                                                    [disabled]="seletedPrimarySpeciality==null" [filter]="true"
                                                    placeholder="Select">
                                                </p-multiSelect>

                                            </div>
                                        </div>
                                        <div class="ui-g-12">
                                            <p>Couldn't find the secondary speciality you're looking for?</p>
                                            <p>(Please type speciality name in input box below and then click on add new
                                                speciality)</p>
                                        </div>
                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-8">
                                                <input id="addedSpeciality" [pKeyFilter]="blockSpecialCharachters"
                                                    type="text" [(ngModel)]="this.addedSpeciality"
                                                    name="addedSpeciality" placeholder="Add New Speciality"
                                                    style="width: 209px; border-color: rgb(16, 151, 16);text-transform:capitalize;"
                                                    pInputText />
                                            </div>
                                            <div class="ui-g-12 ui-lg-4">
                                                <button type="button" pButton
                                                    [disabled]="this.addedSpeciality.length==0"
                                                    (click)="addNewSpeciality()" label="Add New Speciality"></button>
                                            </div>
                                        </div>

                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="salute">Salutation<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <p-dropdown id="salute" [options]="this.salutation" optionLabel="label"
                                                    placeholder="Select" filter="true"
                                                    [style]="{'color': 'black' ,'opacity': 'inherit'}" name="salutation"
                                                    #salute="ngModel" [(ngModel)]="this.selected_salutation" required>
                                                </p-dropdown>
                                                <div *ngIf="!this.doctorreg_boolean.salutation"
                                                    class="alert alert-danger">
                                                    Salutation is required.
                                                </div>
                                                <div *ngIf="salute.invalid && (salute.dirty || salute.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.salutation && salute.errors.required"
                                                        class="invalid">
                                                        Salutation is required.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- <div class="ui-g-12">
                                <div class="ui-g-12">
                                    <input type="text" [pKeyFilter]="block" pInputText placeholder="Add New Speciality in Secondary Speciality"
                                    [(ngModel)]="this.addedSpeciality"  name="addedSpeciality"
                                    style="width:400px">
                                </div>
                                <div class="ui-g-12">
                                    <button Pbutton (click)="addSpeciality()" icon="pi pi-plus" [disabled]="this.addedSpeciality.length==0"
                                        label="Add New Speciality"></button>
                                </div>
                            </div> -->


                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="experince">Experience in Years<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <input id="experince" type="text" pInputText [pKeyFilter]="number_input"
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    name="experince" [(ngModel)]="this.doctorreg.years_experience"
                                                    #experince="ngModel" required />
                                                <div *ngIf="!this.doctorreg_boolean.years_experience"
                                                    class="alert alert-danger">
                                                    Experience in Years is required.
                                                </div>
                                                <div *ngIf="experince.invalid && (experince.dirty || experince.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.years_experience  && experince.errors.required"
                                                        class="invalid">
                                                        Experience is required.
                                                    </div>
                                                    <!-- <div *ngIf="firstname.errors.FieldValidator" class="invalid">
                                                Invalid Experience.
                                            </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="npi_number">NPI/GMC/IMC Number<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <input id="npi_number" type="text"
                                                    [pKeyFilter]="blockSpecialCharachters" pInputText
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    name="npi_number" [(ngModel)]="this.doctorreg.npi_number"
                                                    #npi_number="ngModel" required />
                                                <div *ngIf="!this.doctorreg_boolean.npi_number"
                                                    class="alert alert-danger">
                                                    NPI/MC/IMC Number is required.
                                                </div>
                                                <div *ngIf="npi_number.invalid && (npi_number.dirty || npi_number.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.npi_number && npi_number.errors.required"
                                                        class="invalid">
                                                        NPI/MC/IMC Number is required.
                                                    </div>
                                                    <!-- <div *ngIf="firstname.errors.FieldValidator" class="invalid">
                                                Invalid NPI/MC/IMC Number.
                                            </div> -->
                                                </div>
                                            </div>
                                        </div>

                                        <div class="ui-g-12">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="Degree">Degree<span class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <input id="Degree" type="text" pInputText
                                                    [pKeyFilter]="blockSpecialCharachters"
                                                    style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                    name="Degree" [(ngModel)]="this.doctorreg.degree" #Degree="ngModel"
                                                    required />
                                                <div *ngIf="!this.doctorreg_boolean.degree" class="alert alert-danger">
                                                    Degree is required.
                                                </div>
                                                <div *ngIf="Degree.invalid && (Degree.dirty || Degree.touched)"
                                                    class="alert alert-danger">
                                                    <div *ngIf="this.doctorreg_boolean.degree && Degree.errors.required"
                                                        class="invalid">
                                                        Degree is required.
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="ui-g-12 ui-lg-4">

                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                (Ex:MD,DM,MS.)
                                            </div>
                                        </div>

                                        <div class="ui-g-12">
                                            <!-- <div class="ui-g-12 ui-lg-12"> -->
                                            <label for="revalidation_cme"><b>Revalidation/Recertification Year of
                                                    Medical
                                                    Certificate</b></label>
                                        </div>
                                        <div class="ui-g-12">
                                            <div class="ui-g-8">
                                                <p-dropdown id="revalidation_cme" [options]="years" optionLabel="label"
                                                    placeholder="Select" filter="true" scrollHeight="150px"
                                                    [showClear]="true" name="revalidation_cme"
                                                    #revalidation_cme="ngModel" [(ngModel)]="selectedRevalidation_cme"
                                                    [disabled]="is_revalidation_cme_false"></p-dropdown>

                                            </div>
                                            <div class="ui-g-4">
                                                <p-checkbox name="is_revalidation_cme_false"
                                                    [(ngModel)]='this.is_revalidation_cme_false'
                                                    (onChange)="onRevalidationChange($event)" [binary]="true">
                                                </p-checkbox>
                                                NA
                                            </div>
                                        </div>

                                        <ng-container *ngIf="!this.national_license">
                                            <p-fieldset [style]="{'border':'1px solid #000000'}">
                                                <p-header><b>States to Practice</b><span
                                                        class="doctor-form-req">*</span></p-header>
                                                <div class="ui-g-12">
                                                    <div class="ui-g-12 ui-lg-10">
                                                        <!-- <label for="firstname"><b>States to Practice</b><span
                                                class="doctor-form-req">*</span></label> -->
                                                    </div>
                                                    <div class="ui-g-12 ui-lg-2">
                                                        <button type="button" pButton (click)="showAddStatesDialog()"
                                                            label="Add"></button>
                                                    </div>
                                                </div>
                                                <p-dialog [(visible)]="displayStates" [contentStyle]="{height:'350px'}"
                                                    (onHide)="close()" [style]="{width: '50vw'}"
                                                    header="Add States to Practice" [baseZIndex]="10000">
                                                    <div class="ui-g-12">
                                                        <div class="card no-margin">
                                                            <div class="ui-g">
                                                                <div class="ui-g form-group">
                                                                    <div class="ui-g-8 ui-lg-4">
                                                                        <label for="state_name"> Name<span
                                                                                class="doctor-form-req">*</span></label>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-8">
                                                                        <p-dropdown id="state_name" [options]="states"
                                                                            [(ngModel)]="selectedStateToPratice"
                                                                            optionLabel="state_name"
                                                                            placeholder="Select" name="state_name">
                                                                        </p-dropdown>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-4">
                                                                        <label for="license_number">License Number<span
                                                                                class="doctor-form-req">*</span></label>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-8">
                                                                        <input id="license_number"
                                                                            [pKeyFilter]="blockSpecialCharachters"
                                                                            type="text" [(ngModel)]="License_no"
                                                                            name="license_number"
                                                                            style="width: 260px; border-color: rgb(16, 151, 16);"
                                                                            pInputText />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p-footer>
                                                        <button pButton type="button" class="ui-button-success"
                                                            label="Save" icon="pi pi-save"
                                                            [disabled]="this.selectedStateToPratice==null || this.License_no.length==0"
                                                            (click)="addStatestoPratice()"></button>
                                                        <button pButton type="button" class="ui-button-warning"
                                                            label="Cancel" icon="pi pi-times"
                                                            (click)="close()"></button>
                                                    </p-footer>
                                                </p-dialog>
                                                <p-dialog [(visible)]="editdisplayStatesToPractice"
                                                    [contentStyle]="{height:'350px'}"
                                                    (onHide)="this.canceleditData(this.StatesToPractice_edit_id,'StatesToPractice')"
                                                    [style]="{width: '50vw'}" header="Edit States to Practice"
                                                    [baseZIndex]="10000">
                                                    <div class="ui-g-12">
                                                        <div class="card no-margin">
                                                            <div class="ui-g">
                                                                <div class="ui-g form-group">
                                                                    <div class="ui-g-8 ui-lg-4">
                                                                        <label for="state_name"> Name<span
                                                                                class="doctor-form-req">*</span></label>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-8">
                                                                        <p-dropdown id="state_name" [options]="states"
                                                                            [(ngModel)]="selectedStateToPratice"
                                                                            optionLabel="state_name"
                                                                            placeholder="Select" name="state_name">
                                                                        </p-dropdown>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-4">
                                                                        <label for="license_number">License Number<span
                                                                                class="doctor-form-req">*</span></label>
                                                                    </div>
                                                                    <div class="ui-g-8 ui-lg-8">
                                                                        <input id="license_number"
                                                                            [pKeyFilter]="blockSpecialCharachters"
                                                                            type="text" [(ngModel)]="License_no"
                                                                            name="license_number"
                                                                            style="width: 260px; border-color: rgb(16, 151, 16);"
                                                                            pInputText />
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p-footer>
                                                        <button pButton type="button" class="ui-button-success"
                                                            label="Save" icon="pi pi-save"
                                                            [disabled]="this.selectedStateToPratice==null || this.License_no.length==0"
                                                            (click)="this.saveData(this.StatesToPractice_edit_id,'StatesToPractice')"></button>
                                                        <button pButton type="button" class="ui-button-warning"
                                                            label="Cancel" icon="pi pi-times"
                                                            (click)="this.canceleditData(this.StatesToPractice_edit_id,'StatesToPractice')"></button>
                                                    </p-footer>
                                                </p-dialog>
                                                <div class="ui-g-12">
                                                    <div class="ui-g-12">
                                                        <p-table [value]="StatesToPractice" #dt1
                                                            [value]="StatesToPractice" dataKey="si_no"
                                                            tablestyleClass="p-datatable-customers" [rows]="3"
                                                            [showCurrentPageReport]="true"
                                                            [globalFilterFields]="['si_no','name','License']">
                                                            <ng-template pTemplate="header">
                                                                <tr>
                                                                    <th style="width: 2.5em; text-align: center;">SI No.
                                                                    </th>
                                                                    <th>Name</th>
                                                                    <th>License Number</th>
                                                                    <th style="width: 8em; text-align: center;">
                                                                        <button pButton type="button"
                                                                            icon="pi pi-cog"></button>
                                                                    </th>
                                                                </tr>
                                                            </ng-template>
                                                            <ng-template pTemplate="body" let-product>
                                                                <tr>
                                                                    <td style="width: 2.5em; text-align: center;">
                                                                        {{product.si_no}}</td>
                                                                    <td class="tdentry">{{product.state_name}}</td>
                                                                    <td class="tdentry">{{product.license_no}}</td>
                                                                    <td style="width: 8em; text-align: center;">
                                                                        <button pButton type="button"
                                                                            class="ui-button-warning"
                                                                            icon="pi pi-pencil"
                                                                            (click)="editData(product.si_no,'StatesToPractice')"></button>
                                                                        <button pButton type="button"
                                                                            class="ui-button-danger" icon="pi pi-trash"
                                                                            (click)="confirmStatesToPracticeSelectDelete($event,product)"
                                                                            style="margin-left: .5em"></button>
                                                                    </td>
                                                                </tr>
                                                            </ng-template>
                                                        </p-table>
                                                    </div>
                                                </div>
                                                <div *ngIf="!this.doctorreg_boolean.states_to_practice"
                                                    class="alert alert-danger">
                                                    States to Practice is required.
                                                </div>
                                            </p-fieldset>
                                        </ng-container>
                                        <ng-container *ngIf="this.national_license">
                                            <div class="ui-g-12 ui-lg-4">
                                                <label for="License">License No<span
                                                        class="doctor-form-req">*</span></label>
                                            </div>
                                            <div class="ui-g-12 ui-lg-8">
                                                <input id="License" type="text" pInputText style="width: 260px;"
                                                    name="License" #License="ngModel"
                                                    [(ngModel)]="this.national_license_no" />
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.states_to_practice"
                                                class="alert alert-danger">
                                                License No is required.
                                            </div>
                                            <div *ngIf="License.invalid && (License.dirty || License.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.states_to_practice && License.errors.required"
                                                    class="invalid">
                                                    License No is required.
                                                </div>
                                            </div>
                                        </ng-container>

                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Medical School</b><span class="doctor-form-req">*</span>
                                            </p-header>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <!-- <label for="lastname"><b>Medical School</b><span class="doctor-form-req">*</span></label> -->
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton (click)="showAddMedicalSchoolDialog()"
                                                        label="Add"></button>
                                                </div>
                                            </div>

                                            <p-dialog [(visible)]="displayMedicalSchool"
                                                [contentStyle]="{height:'350px'}" (onHide)="close()"
                                                [style]="{width: '50vw'}" header="Add Medical School"
                                                [baseZIndex]="10000">
                                                <!-- <p-header>
                                            Add a Condition
                                        </p-header> -->
                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <!-- <div class="ui-g-12 "> -->
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Medical_School">Medical School Name<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Medical_School"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Medical_School"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year of
                                                                        Graduation<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">

                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="addMedicalSchool()"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times" (click)="close()"></button>
                                                </p-footer>
                                            </p-dialog>
                                            <p-dialog [(visible)]="editdisplayMedicalSchool"
                                                [contentStyle]="{height:'350px'}"
                                                (onHide)="this.canceleditData(this.medicalSchool_edit_id,'MedicalSchool')"
                                                [style]="{width: '50vw'}" header="Edit Medical School"
                                                [baseZIndex]="10000">

                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Medical_School">Medical School Name<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Medical_School"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Medical_School"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year of
                                                                        Graduation<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="this.saveData(this.medicalSchool_edit_id,'MedicalSchool')"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times"
                                                        (click)="this.canceleditData(this.medicalSchool_edit_id,'MedicalSchool')"></button>
                                                </p-footer>
                                            </p-dialog>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="medicalSchool" #dt1 dataKey="si_no"
                                                        tablestyleClass="p-datatable-customers" [rows]="3"
                                                        [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name','year']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th>Year of Graduation</th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td class="WordWrap format-lines" class="tdentry">
                                                                    {{product.name}}</td>
                                                                <td class="tdentry">{{product.year}}</td>
                                                                <td style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'MedicalSchool')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmMedicalSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.medical_school"
                                                class="alert alert-danger">
                                                Medical School is required.
                                            </div>
                                        </p-fieldset>

                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Residency/Specialist Training/PG</b><span
                                                    class="doctor-form-req">*</span>
                                            </p-header>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <!-- <label for="firstname"><b>Residency/Specialist Training/PG</b><span
                                            class="doctor-form-req">*</span></label> -->
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton (click)="showAddResidencyDialog()"
                                                        label="Add"></button>
                                                </div>
                                            </div>
                                            <p-dialog [(visible)]="displayResidency" [contentStyle]="{height:'350px'}"
                                                (onHide)="close()" [style]="{width: '50vw'}"
                                                header="Add Residency/Specialist Training/PG" [baseZIndex]="10000">
                                                <!-- <p-header>
                                            Add a Condition
                                        </p-header> -->
                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <!-- <div class="ui-g-12 "> -->
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Residency_name"> Name <span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Residency_name"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Residency_name"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year<span
                                                                            class="doctor-form-req">*</span>
                                                                    </label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">

                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="addResidency()"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times" (click)="close()"></button>
                                                </p-footer>
                                            </p-dialog>

                                            <p-dialog [(visible)]="editdisplayResidency"
                                                [contentStyle]="{height:'350px'}"
                                                (onHide)="this.canceleditData(this.residency_edit_id,'Residency')"
                                                [style]="{width: '50vw'}" header="Edit Residency/Specialist Training/PG"
                                                [baseZIndex]="10000">

                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Residency_name"> Name<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Residency_name"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Residency_name"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year <span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">

                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="this.saveData(this.residency_edit_id,'Residency')"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times"
                                                        (click)="this.canceleditData(this.residency_edit_id,'Residency')"></button>
                                                </p-footer>
                                            </p-dialog>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Residency" #dt1 dataKey="si_no"
                                                        tablestyleClass="p-datatable-customers" [rows]="3"
                                                        [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th>Year </th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td class="tdentry WordWrap format-lines">
                                                                    {{product.name}}</td>
                                                                <td class="tdentry">{{product.year}}</td>
                                                                <td style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Residency')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmResidencySelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.residency" class="alert alert-danger">
                                                Residency/Specialist Training/PG is required.
                                            </div>
                                        </p-fieldset>


                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Fellowship</b></p-header>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <!-- <label for="firstname"><b>Fellowship</b><span class="doctor-form-req">*</span></label> -->
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton (click)="showAddFellowshipDialog()"
                                                        label="Add"></button>
                                                </div>
                                            </div>
                                            <p-dialog [(visible)]="displayFellowship" [contentStyle]="{height:'350px'}"
                                                (onHide)="close()" [style]="{width: '50vw'}" header="Add Fellowship"
                                                [baseZIndex]="10000">
                                                <!-- <p-header>
                                            Add a Condition
                                        </p-header> -->
                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <!-- <div class="ui-g-12 "> -->
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Fellowship_name"> Name<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Fellowship_name"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Fellowship_name"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year <span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">

                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="addFellowship()"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times" (click)="close()"></button>
                                                </p-footer>
                                            </p-dialog>

                                            <p-dialog [(visible)]="editdisplayFellowship"
                                                [contentStyle]="{height:'350px'}"
                                                (onHide)="this.canceleditData(this.fellowship_edit_id,'Fellowship')"
                                                [style]="{width: '50vw'}" header="Edit Fellowship" [baseZIndex]="10000">
                                                <!-- <p-header>
                                            Add a Condition
                                        </p-header> -->
                                                <div class="ui-g-12">
                                                    <div class="card no-margin">
                                                        <div class="ui-g">
                                                            <div class="ui-g form-group">
                                                                <!-- <div class="ui-g-12 "> -->
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="Fellowship_name"> Name<span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">
                                                                    <input id="Fellowship_name"
                                                                        [pKeyFilter]="blockSpecialCharachters"
                                                                        type="text" [(ngModel)]="name"
                                                                        name="Fellowship_name"
                                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                                        pInputText />
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-4">
                                                                    <label for="year_of_graduation">Year <span
                                                                            class="doctor-form-req">*</span></label>
                                                                </div>
                                                                <div class="ui-g-8 ui-lg-8">

                                                                    <p-dropdown id="year_of_graduation"
                                                                        [options]="years" placeholder="Select"
                                                                        filter="true" scrollHeight="150px"
                                                                        [showClear]="true" [style]="{'width':'209px'}"
                                                                        name="year_of_graduation"
                                                                        [(ngModel)]="year_of_graduation"></p-dropdown>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p-footer>
                                                    <button pButton type="button" class="ui-button-success" label="Save"
                                                        icon="pi pi-save"
                                                        [disabled]="this.name.length==0 || this.year_of_graduation==null"
                                                        (click)="this.saveData(this.fellowship_edit_id,'Fellowship')"></button>
                                                    <button pButton type="button" class="ui-button-warning"
                                                        label="Cancel" icon="pi pi-times"
                                                        (click)="this.canceleditData(this.fellowship_edit_id,'Fellowship')"></button>
                                                </p-footer>
                                            </p-dialog>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Fellowship" #dt1 dataKey="si_no"
                                                        tablestyleClass="p-datatable-customers" [rows]="3"
                                                        [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name','year']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th>Year </th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td class="tdentry WordWrap format-lines">
                                                                    {{product.name}}</td>
                                                                <td class="tdentry">{{product.year}}</td>
                                                                <td style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Fellowship')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmFellowshipSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </div>
                                        </p-fieldset>

                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Board Certifications</b><span class="doctor-form-req">*</span>
                                            </p-header>
                                            <div class="ui-g-12">
                                                <!-- <label for="board_certification_name"><b>Board Certification</b></label> -->
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <input id="board_certification_name"
                                                        [pKeyFilter]="blockSpecialCharachters" type="text"
                                                        [(ngModel)]="this.board_certification_name"
                                                        name="board_certification_name"
                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                        pInputText />
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton
                                                        [disabled]="this.board_certification_name.length==0"
                                                        (click)="addBoard()" label="Add"></button>
                                                </div>
                                            </div>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Board" #dt1 [value]="Board" dataKey="si_no"
                                                        tablestyleClass="p-datatable-customers" [rows]="3"
                                                        [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td *ngIf="Boards_edit_id!=product.si_no"
                                                                    class="tdentry WordWrap format-lines">
                                                                    {{product.name}}
                                                                </td>
                                                                <td *ngIf="Boards_edit_id==product.si_no"
                                                                    class="tdentry">
                                                                    <input type="text" style="width:160px;" pInputText
                                                                        name="edited_boards_name"
                                                                        [(ngModel)]="this.edited_boards_name">
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Boards_edit_id!=product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Boards')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmBoardsSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Boards_edit_id==product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-times"
                                                                        (click)="canceleditData(product.si_no,'Boards')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-success" icon="pi pi-save"
                                                                        (click)="saveData(product.si_no,'Boards')"
                                                                        [disabled]="edited_boards_name.length==0"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>

                                                </div>
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.board_certification"
                                                class="alert alert-danger">
                                                Board Certifications is required.
                                            </div>
                                        </p-fieldset>

                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Publications</b></p-header>
                                            <div class="ui-g-12">
                                                <!-- <label for="publication_name"><b>Publications</b></label> -->
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <input id="publication_name" [pKeyFilter]="blockSpecialCharachters"
                                                        type="text" [(ngModel)]="this.publication_name"
                                                        name="publication_name"
                                                        style="width: 209px; border-color: rgb(16, 151, 16);"
                                                        pInputText />
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton
                                                        [disabled]="this.publication_name.length==0"
                                                        (click)="addPublication()" label="Add"></button>
                                                </div>
                                            </div>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Publication" #dt1 [value]="Publication"
                                                        dataKey="si_no" tablestyleClass="p-datatable-customers"
                                                        [rows]="3" [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td *ngIf="Publication_edit_id!=product.si_no"
                                                                    class="tdentry WordWrap format-lines">
                                                                    {{product.name}}</td>
                                                                <td *ngIf="Publication_edit_id==product.si_no"
                                                                    class="tdentry">
                                                                    <input type="text" style="width:160px;" pInputText
                                                                        name="edited_pub_name"
                                                                        [(ngModel)]="this.edited_publication_name">
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Publication_edit_id!=product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Publication')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmPublicationSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Publication_edit_id==product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-times"
                                                                        (click)="canceleditData(product.si_no,'Publication')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-success" icon="pi pi-save"
                                                                        (click)="saveData(product.si_no,'Publication')"
                                                                        [disabled]="edited_publication_name.length==0"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>

                                                </div>
                                            </div>
                                        </p-fieldset>



                                        <!-- <ng-container *ngIf="this.national_license">
                                    <div class="ui-g-12 ui-lg-6">
                                        <label for="firstname">States to Practice<span class="doctor-form-req">*</span></label>
                                    </div>
                                    <div class="ui-g-12 ui-lg-6">

                                    </div>
                                </ng-container> -->
                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Honours/Rewards/Recognitions</b></p-header>
                                            <div class="ui-g-12">
                                                <!-- <label for="award_name"><b>Honours/Rewards/Recognition</b> </label> -->
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <input id="award_name" [pKeyFilter]="blockSpecialCharachters"
                                                        type="text" [(ngModel)]="honour_name"
                                                        style="width: 209px; border-color: rgb(16, 151, 16);" pInputText
                                                        name="award_name" />
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton [disabled]="honour_name.length==0"
                                                        (click)="addHonours()" label="Add"></button>
                                                </div>
                                            </div>

                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Honours" #dt1 [value]="Honours" dataKey="si_no"
                                                        tablestyleClass="p-datatable-customers" [rows]="3"
                                                        [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td *ngIf="Honours_edit_id!=product.si_no"
                                                                    class="tdentry WordWrap format-lines">
                                                                    {{product.name}}
                                                                </td>
                                                                <td *ngIf="Honours_edit_id==product.si_no"
                                                                    class="tdentry">
                                                                    <input type="text" style="width:160px;" pInputText
                                                                        name="edited_honours_name"
                                                                        [(ngModel)]="this.edited_honour_name">
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Honours_edit_id!=product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Honours')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmHonoursSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Honours_edit_id==product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-times"
                                                                        (click)="canceleditData(product.si_no,'Honours')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-success" icon="pi pi-save"
                                                                        (click)="saveData(product.si_no,'Honours')"
                                                                        [disabled]="edited_honour_name.length==0"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </div>
                                        </p-fieldset>
                                        <p-fieldset [style]="{'border':'1px solid #000000'}">
                                            <p-header><b>Hospital Privileges to Practice</b></p-header>
                                            <div class="ui-g-12">
                                                <!-- <label for="firstname"><b>Hospital Privileges to Practice </b></label> -->
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12 ui-lg-10">
                                                    <input id="privileges_name" [pKeyFilter]="blockSpecialCharachters"
                                                        type="text" [(ngModel)]="this.privileges_name"
                                                        style="width: 209px; border-color: rgb(16, 151, 16);" pInputText
                                                        name="privileges_name" />
                                                </div>
                                                <div class="ui-g-12 ui-lg-2">
                                                    <button type="button" pButton
                                                        [disabled]="this.privileges_name.length==0"
                                                        (click)="addPrivileges()" label="Add"></button>
                                                </div>
                                            </div>
                                            <!-- <div class="ui-g-12 ui-lg-6">
                                    <button type="button" pButton (click)="showAddPrivilegesDialog()"  label="Add"></button>
                                </div>
                                <p-dialog [(visible)]="displayPrivileges" [style]="{width: '50vw'}" header="Add Privileges" [baseZIndex]="10000">
                                    <div class="ui-g-12">
                                  <div class="card no-margin">
                                   <div class="ui-g">
                                    <div class="ui-g form-group">
                                               <div class="ui-g-8 ui-lg-4">
                                                   <label for="award_name"> Name</label>
                                               </div>
                                               <div class="ui-g-8 ui-lg-8">
                                                   <input id="award_name" [pKeyFilter]="block" type="text" style="width: 209px; border-color: rgb(16, 151, 16);"  pInputText   required/>
                                               </div>


                                 </div>
                                 </div>
                                 </div>
                                 </div>
                                     <p-footer>
                                         <button pButton type="button" class="ui-button-success" label="Save" icon="pi pi-save"  ></button>
                                         <button pButton type="button" class="ui-button-warning" label="Cancel" icon="pi pi-times" (click)="close()"></button>
                                     </p-footer>
                                 </p-dialog> -->
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-table [value]="Privileges" #dt1 [value]="Privileges"
                                                        dataKey="si_no" tablestyleClass="p-datatable-customers"
                                                        [rows]="3" [showCurrentPageReport]="true"
                                                        [globalFilterFields]="['si_no','name']">
                                                        <ng-template pTemplate="header">
                                                            <tr>
                                                                <th style="width: 2.5em; text-align: center;">SI No.
                                                                </th>
                                                                <th>Name</th>
                                                                <th style="width: 8em; text-align: center;">
                                                                    <button pButton type="button"
                                                                        icon="pi pi-cog"></button>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-product>
                                                            <tr>
                                                                <td style="width: 2.5em; text-align: center;">
                                                                    {{product.si_no}}</td>
                                                                <td *ngIf="Privileges_edit_id!=product.si_no"
                                                                    class="tdentry WordWrap format-lines">
                                                                    {{product.name}}</td>
                                                                <td *ngIf="Privileges_edit_id==product.si_no"
                                                                    class="tdentry">
                                                                    <input type="text" style="width:160px;" pInputText
                                                                        name="edited_privs_name"
                                                                        [(ngModel)]="this.edited_privileges_name">
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Privileges_edit_id!=product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-warning" icon="pi pi-pencil"
                                                                        (click)="editData(product.si_no,'Privileges')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-trash"
                                                                        (click)="confirmPrivilegesSelectDelete($event,product)"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                                <td style="width: 8em; text-align: center;"
                                                                    *ngIf="Privileges_edit_id==product.si_no">
                                                                    <button pButton type="button"
                                                                        class="ui-button-danger" icon="pi pi-times"
                                                                        (click)="canceleditData(product.si_no,'Privileges')"></button>
                                                                    <button pButton type="button"
                                                                        class="ui-button-success" icon="pi pi-save"
                                                                        (click)="saveData(product.si_no,'Privileges')"
                                                                        [disabled]="edited_privileges_name.length==0"
                                                                        style="margin-left: .5em"></button>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                </div>
                                            </div>
                                        </p-fieldset>

                                        <div class="ui-g-12">
                                            <p-checkbox [(ngModel)]="this.changePhoto" [value]="this.changePhoto"
                                                [binary]="true" #photochange="ngModel" name="photochange"></p-checkbox>
                                            Change Profile Photo
                                        </div>
                                        <div *ngIf="this.changePhoto">
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <p-fieldset styleClass="sample-photo-fieldset">
                                                        <p-header>
                                                            Sample Profile Photo
                                                        </p-header>
                                                        <img src="./assets/images/samplePhotos/doc001.jpg"
                                                            alt="Sample Photo" class="sample-photo-doctor-registration">
                                                        <img src="./assets/images/samplePhotos/doc002.jpg"
                                                            alt="Sample Photo" class="sample-photo-doctor-registration">
                                                        <div class="ui-g-12"
                                                            style="text-align: center;font-weight: bold;">
                                                            Recommended Image Dimensions
                                                            <p>800 pixels X 850 pixels</p>
                                                        </div>
                                                    </p-fieldset>
                                                </div>
                                            </div>
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <label for="photot">Profile Photo<span
                                                            class="doctor-form-req">*</span></label>
                                                    <ng-container
                                                        *ngIf="this.avatar_url!=null && this.avatar_url.length>0">
                                                        <a href="javascript:void(0)" style="cursor:pointer"
                                                            (click)="download(this.avatar_url,'Profile_Photo')">
                                                            Download Profile Photo
                                                        </a>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="this.avatar_url==null ||  this.avatar_url?.length==0">
                                                        No Profile Photo Uploaded
                                                    </ng-container>
                                                    <!-- <input pButton type="button" label="Download Profile Photo" (onClick)="download(this.avatar_url)"> -->
                                                </div>
                                                <div class="ui-g-12">
                                                    <p-fileUpload name="photo" id="photo" (onRemove)="onRemovePhoto()"
                                                        (onSelect)="uploadProfileFiles($event.files)"
                                                        styleClass="p-fileUpload-label-fix" [showCancelButton]="false"
                                                        [showUploadButton]="false" [maxFileSize]="5033165"
                                                        multiple="false" [fileLimit]="1" accept="image/*">
                                                    </p-fileUpload>
                                                </div>
                                                <div class="alert alert-danger" role="alert">
                                                    <p class="text-center text-gray-underline"><span
                                                            class="font-weight-bold">Note</span>:
                                                        The
                                                        file type supported for Profile Photo are JPEG,JPG,PNG.</p>
                                                </div>
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.profile_photo"
                                                class="alert alert-danger">
                                                Profile Photo is required.
                                            </div>
                                        </div>

                                        <div class="ui-g-12" *ngIf="!editOthers">
                                            <p-checkbox [(ngModel)]="this.changeResume" [value]="this.changeResume"
                                                [binary]="true" #resumechange="ngModel" name="Resumechange">
                                            </p-checkbox>
                                            Change Resume
                                        </div>
                                        <div *ngIf="this.changeResume">
                                            <div class="ui-g-12">
                                                <div class="ui-g-12">
                                                    <label for="zip">Resume/CV<span
                                                            class="doctor-form-req">*</span></label>
                                                    <ng-container
                                                        *ngIf="this.resume_url!=null && this.resume_url.length>0">
                                                        <a href="javascript:void(0)" style="cursor:pointer"
                                                            (click)="download(this.resume_url,'Resume')">
                                                            Download Resume
                                                        </a>
                                                    </ng-container>
                                                    <ng-container
                                                        *ngIf="this.resume_url==null ||  this.resume_url?.length==0">
                                                        No Resume File Uploaded
                                                    </ng-container>
                                                </div>
                                                <div class="ui-g-12">
                                                    <p-fileUpload name="resume" id="resume"
                                                        (onRemove)="onRemoveResume()"
                                                        styleClass="p-fileUpload-label-fix"
                                                        (onSelect)="uploadResumeFiles($event.files)"
                                                        [showUploadButton]="false" [showCancelButton]="false"
                                                        [maxFileSize]="5033165" multiple="false" [fileLimit]="1"
                                                        accept=".pdf">
                                                    </p-fileUpload>
                                                </div>
                                            </div>
                                            <div *ngIf="!this.doctorreg_boolean.resume_cv" class="alert alert-danger">
                                                Resume/CV is required.
                                            </div>
                                            <div class="alert alert-danger" role="alert">
                                                <p class="text-center text-gray-underline"><span
                                                        class="font-weight-bold">Note</span>: The
                                                    file type supported for Resume/CV is PDF.</p>
                                            </div>
                                        </div>

                                        <ng-container *ngIf="!editOthers">
                                            <div class="ui-g-12">
                                                <p-checkbox [(ngModel)]="this.changePin" [value]="this.changePin"
                                                    [binary]="true" #pinchange="ngModel" name="pinchange"></p-checkbox>
                                                Change
                                                Pin
                                            </div>
                                            <div *ngIf="this.changePin">
                                                <div class="ui-g-12">
                                                    <label for="pin">Set your 4 digit pin<span
                                                            class="doctor-form-req">*</span></label>
                                                </div>
                                                <div class="ui-g-12">
                                                    <input id="pin" [type]="this.pinMasking?'password':'text'"
                                                        pInputText [pKeyFilter]="number_input" maxlength=4
                                                        [(ngModel)]="this.doctorreg.pin"
                                                        style="width: 260px; border-color: rgb(16, 151, 16); color: black; opacity: inherit;"
                                                        name="pin" />
                                                    <span toggle="#password-field" [ngClass]="{
                                                            'fa fa-fw fa-eye': this.pinMasking,
                                                            'pi pi-eye-slash': !this.pinMasking
                                                            }" style="color:black;margin:auto;padding-left:5px;"
                                                        (click)="changePinType()"></span>

                                                </div>
                                                <div *ngIf="!this.doctorreg_boolean.pin" class="alert alert-danger">
                                                    Pin is required.
                                                </div>
                                            </div>
                                        </ng-container>

                                        <ng-container *ngIf="!editOthers">
                                            <div class="ui-g-12">
                                                <p-checkbox [(ngModel)]="this.changeSignature"
                                                    [value]="this.changeSignature" [binary]="true"
                                                    #signaturechange="ngModel" name="signaturechange">
                                                </p-checkbox> Change Signature
                                            </div>
                                            <!-- ngStyle is use beacuse canvas will throw error -->
                                            <div *ngIf="this.changeSignature">
                                                <div class="ui-g-12">
                                                    <label for="esign">eSignature<span
                                                            class="doctor-form-req">*</span></label>
                                                </div>
                                                <div class="ui-g-12 ui-lg-6">
                                                    <div class="ui-g-12">
                                                        <div class="ui-g">
                                                            <div class="ui-g-12 ui-lg-4" style="width:60%">
                                                                <p-radioButton id="esign" name="signatureOption"
                                                                    value="draw" label="Draw"
                                                                    [(ngModel)]="this.signatureOptionSelected"
                                                                    (click)="changeSignatureOption()"
                                                                    name="signatureOption" #signatureOption="ngModel">
                                                                </p-radioButton>
                                                            </div>
                                                            <div class="ui-g-12 ui-lg-4" style="width:60%">
                                                                <p-radioButton id="esign" name="signatureOption"
                                                                    value="upload" label="Upload"
                                                                    [(ngModel)]="this.signatureOptionSelected"
                                                                    (click)="changeSignatureOption()"
                                                                    name="signatureOption" #signatureOption="ngModel">
                                                                </p-radioButton>
                                                            </div>
                                                            <div *ngIf="signatureOption.invalid && (signatureOption.dirty || signatureOption.touched)"
                                                                class="alert alert-danger">
                                                                <div *ngIf="signatureOption.errors.required"
                                                                    class="invalid">
                                                                    Choose a Signature Method.
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <canvas #canvas name="canvas"
                                                            *ngIf="this.signatureOptionSelected==='draw'"
                                                            class="canvass"></canvas>
                                                        <button type="button" pButton (click)="clearSignatureDraw()"
                                                            *ngIf="this.signatureOptionSelected==='draw'"
                                                            style="margin-top: 6px;" label="Clear"
                                                            icon="pi pi-times"></button>

                                                        <button type="button" pButton (click)="addSignature()"
                                                            *ngIf="this.signatureOptionSelected==='upload'"
                                                            label="Upload a Signature"></button>
                                                    </div>
                                                    <div
                                                        *ngIf="(this.signatureOptionSelected!=null && this.signature_file_name.length>=0 && this.signatureOptionSelected==='upload' && !this.signature_file_type_error)">
                                                        <img [src]="croppedImage"
                                                            [style.border]="croppedImage ? '1px solid black' : 'none'" />
                                                        {{this.signature_file_name}}
                                                    </div>
                                                </div>
                                                <div *ngIf="!this.doctorreg_boolean.signature"
                                                    class="alert alert-danger">
                                                    eSignature is required.
                                                </div>
                                            </div>
                                        </ng-container>

                                        <div class="ui-g-12">
                                            <label for="description">Description about yourself (Bio) <span
                                                    class="doctor-form-req">*</span>:</label>
                                        </div>

                                        <div class="ui-g-12">
                                            <textarea id="description" [pKeyFilter]="textarea"
                                                [(ngModel)]="doctorreg.description" name="description" maxlength="5000"
                                                pInputTextarea
                                                class="WordWrap format-lines textarea-doctor-registration"
                                                #description="ngModel" required></textarea>
                                            <div *ngIf="!this.doctorreg_boolean.description" class="alert alert-danger">
                                                Description about yourself is mandatory.
                                            </div>
                                            <div *ngIf="description.invalid && (description.dirty || description.touched)"
                                                class="alert alert-danger">
                                                <div *ngIf="this.doctorreg_boolean.description &&  description.errors.required"
                                                    class="invalid">
                                                    Description about yourself is mandatory.
                                                </div>
                                            </div>

                                        </div>
                                        <div class="ui-g-12" style="float: left;">
                                            <p [style.color]="doctorreg.description?.length-4999>0?'red':'green'"
                                                style="float: left;">
                                                {{(5001-doctorreg.description?.length)
                                                <0?0:5000-doctorreg.description?.length}} of 5000 left</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </p-fieldset>
                        <div class="container-flex row text-gray-underline">
                            <h4><b>Note</b>: PIN and eSignature are required to prescribe and validate medications</h4>
                        </div>
                    </ng-container>
                    <!-- <div class="container text-center justify-content-center">
                <p style="padding-left:25%;">
                    <p-checkbox [(ngModel)]="agree" (onChange)="onAgreeChange($event)" [binary]="true"
                        [ngModelOptions]="{standalone: true}"></p-checkbox>
                    <span style="padding-left: 2%;">I agree that above information are accurate to best of my
                        knowledge</span>
                </p>
            </div> -->

                    <div>
                        <div id="recaptcha-div2">
                            <re-captcha *ngIf="recaptcha_Reset" class="recaptcha ng-valid" name="recaptcha" matInput
                                style="display: inline-block;" (resolved)="resolved($event)"
                                [(ngModel)]="doctorreg.recaptcha" #recaptcha="ngModel" [siteKey]="sitekey" required>
                            </re-captcha>
                        </div>
                        <div *ngIf="!this.doctorreg_boolean.recaptcha" class="alert alert-danger">
                            Recaptcha is required.
                        </div>
                    </div>


                    <div class="ui-g-12">
                        <div class="row container justify-content-center text-center alert alert-danger"
                            *ngIf="error_message_result?.success!=null && error_message_result?.success==false && error_message_result?.data!=null && error_message_result?.data.length>0">
                            <p>Following fields are not filled:</p>
                            <p *ngFor="let message of error_message_result.data ;let i = index">{{(i+1) +". "+ message}}
                            </p>
                        </div>
                    </div>

                    <div class="ui-g-12">
                        <!-- <div class="row container justify-content-center text-center alert alert-danger"
                    *ngIf="response.success!=null && response.success==false"> -->
                        <div class="row container justify-content-center text-center alert alert-danger"
                            *ngIf="response.success!=null && !response.success">
                            <p *ngIf="response.error!=null">{{response.error.message}}</p>
                            <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
                                <p *ngFor="let message of serverError?.message">{{message}}</p>
                            </div>
                            <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
                                <p>{{serverError?.message}}</p>
                            </div>

                        </div>
                    </div>

                    <!-- [disabled]="(
                                    (
                                        (this.changePassword && this.password!=this.confirmPassword && this.password.length==0 && this.confirmPassword.length==0)
                                        || (this.changePhoto && this.profilePhoto==null)
                                        || (this.changePin && this.doctorreg?.pin?.length==0)
                                        || (this.changeSignature && this.signatureOptionSelected==null)
                                        || (this.changeSignature && this.signatureOptionSelected=='upload' && this.signature_file_type_error && this.signatureFile==null)
                                        || (this.changeResume && this.resume==null)
                                        || (this.changePin && this.doctorreg?.pin=='')
                                        || this.medicalSchool.length==0
                                        || this.Board.length==0
                                        || this.Residency.length==0
                                        || (!national_license && this.StatesToPractice.length==0)
                                        || (national_license && this.national_license_no.length==0)
                                        || !doctorregistrationform.valid
                                        || (this.is_revalidation_cme_false==false && selectedRevalidation_cme==null)
                                        || this.posting==true
                                    )
                                        &&
                                    (
                                        this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']
                                    )
                                )
                                ||
                                (
                                    (
                                        (this.changePassword && this.password!=this.confirmPassword && this.password.length==0 && this.confirmPassword.length==0)
                                        || (this.changePhoto && this.profilePhoto==null)
                                        || !doctorregistrationform.valid
                                        || (this.is_revalidation_cme_false==false && selectedRevalidation_cme==null)
                                        || this.posting==true
                                    )
                                        &&
                                    (
                                        this.currentRoleID==this.available_roles['Admin'] || this.currentRoleID==this.available_roles['SuperAdmin'] || this.currentRoleID==this.available_roles['Other_Medical_Professional_Admin']
                                    )
                                ) -->

                    <div style="align-items: center;">
                        <p-progressSpinner *ngIf="this.posting==true"
                            [style]="{'width': '25px', 'height': '25px', 'vertical-align' : 'middle'}" strokeWidth="6">
                        </p-progressSpinner>
                        <p-button type="submit" [disabled]="(
                                    (
                                         this.posting==true
                                    )
                                        &&
                                    (
                                        this.currentRoleID==this.available_roles['Doctor'] || this.currentRoleID==this.available_roles['SuperAdmin_Doctor'] || this.currentRoleID==this.available_roles['Admin_Doctor']
                                    )
                                )
                                ||
                                (
                                    (
                                        (this.changePassword && this.password!=this.confirmPassword && this.password.length==0 && this.confirmPassword.length==0)
                                        || (this.changePhoto && this.profilePhoto==null)
                                        || !doctorregistrationform.valid
                                        || this.posting==true
                                    )
                                        &&
                                    (
                                        this.currentRoleID==this.available_roles['Admin'] || this.currentRoleID==this.available_roles['SuperAdmin'] || this.currentRoleID==this.available_roles['Other_Medical_Professional_Admin']
                                    )
                                )
                                " [style]="{'align-items':'center'}" label="Update" class="p-button-lg"
                            icon="pi pi-check">
                        </p-button>
                        <p-button type="button" [style]="{'margin-left':'5%','align-items':'center'}" label="Cancel"
                            [disabled]="this.posting==true" class="p-button-lg" (click)="gotodashboard()"></p-button>
                    </div>

                </div>
            </div>

            <p-dialog *ngIf="this.noteDialog" [(visible)]="noteDialog" [style]="{width: '80vw'}" (onHide)="close()"
                header="Please  read before filling the form" [baseZIndex]="10000">
                <app-note-doctors [doctorEdit]="true" [save]="false" [othermedical]="false" [localSave]="false">
                </app-note-doctors>
                <button pButton type="button" class="ui-button-success" label="Close" icon="pi pi-times"
                    (click)="this.noteDialog=false"
                    style="display:flex;margin-left:auto;margin-right:auto;margin-top:3%;"></button>
            </p-dialog>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-medicalSchool" header="Delete Medical School" acceptLabel="Yes"
                    rejectLabel="No" [(visible)]="confirmDialogVisible1"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-fellowship" header="Delete Fellowship" acceptLabel="Yes"
                    rejectLabel="No" [(visible)]="confirmDialogVisible2"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-residency" header="Delete Residency/Specialist Training/PG"
                    acceptLabel="Yes" rejectLabel="No" [(visible)]="confirmDialogVisible3"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-honours" header="Delete Honours/Rewards/Recognitions"
                    acceptLabel="Yes" rejectLabel="No" [(visible)]="confirmDialogVisible4"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-privileges" header="Delete Hospital Privileges to Practice"
                    acceptLabel="Yes" rejectLabel="No" [(visible)]="confirmDialogVisible5"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-boards" header="Delete Board Certifications" acceptLabel="Yes"
                    rejectLabel="No" [(visible)]="confirmDialogVisible6"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-publication" header="Delete Publications" acceptLabel="Yes"
                    rejectLabel="No" [(visible)]="confirmDialogVisible7"></p-confirmDialog>
            </div>

            <div class="mat-elevation-z8">
                <p-confirmDialog key="confirm-delete-StatesToPractice" header="Delete States to Practice"
                    acceptLabel="Yes" rejectLabel="No" [(visible)]="confirmDialogVisible8"></p-confirmDialog>
            </div>


            <p-dialog *ngIf="this.signatureDialog" [(visible)]="signatureDialog" [contentStyle]="{height:'750px'}"
                [style]="{width: '80vw'}" (onHide)="close()" header="Upload Signature" [baseZIndex]="10000">
                <div class="ui-g-12 text-gray-underline">
                    <b>Note :</b>Supported signature file types are JPEG, JPG and PNG.
                </div>
                <div class="ui-g-12">
                    <!-- <label class="button" for="upload">Upload File</label> -->
                    <input id='upload' type="file" accept="image/*" (change)="fileChangeEvent($event)" />
                </div>
                <div class="ui-g-12" style="color: red;">
                    <ng-container *ngIf="this.signature_file_type_error">
                        Not a supported file type.
                    </ng-container>
                </div>
                <ng-container *ngIf="!this.signature_file_type_error">
                    <div *ngIf="showCropper">
                        <div class="ui-g-12 doctor-submit-button-group">
                            <button pButton type="button" class="p-button-info" (click)="rotateLeft()">Rotate
                                left</button>
                            <button pButton type="button" class="p-button-info" (click)="rotateRight()">Rotate
                                right</button>
                            <button pButton type="button" class="p-button-info" (click)="flipHorizontal()">Flip
                                horizontal</button>
                            <button pButton type="button" class="p-button-info" (click)="flipVertical()">Flip
                                vertical</button>
                        </div>
                        <div class="ui-g-12 doctor-submit-button-group">
                            <button pButton type="button" class="p-button-info"
                                (click)="toggleContainWithinAspectRatio()">
                                {{containWithinAspectRatio?'Fill Aspect Ratio':'Contain Within Aspect Ratio'}}
                            </button>
                            <button pButton type="button" class="p-button-info" (click)="resetImage()">Reset
                                image</button>
                        </div>
                        <div class="ui-g-12 doctor-submit-button-group">
                            <button pButton type="button" class="p-button-info" (click)="zoomOut()">Zoom -</button>
                            <button pButton type="button" class="p-button-info" (click)="zoomIn()">Zoom +</button>
                        </div>
                    </div>
                    <div class="ui-g-12">
                        <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                            [containWithinAspectRatio]="containWithinAspectRatio" [aspectRatio]="4 / 3"
                            [resizeToWidth]="256" [cropperMinWidth]="128" [onlyScaleDown]="true" [roundCropper]="false"
                            [canvasRotation]="canvasRotation" [transform]="transform" [alignImage]="'left'"
                            [style.display]="showCropper ? null : 'none'"
                            [style.border]="showCropper ? '1px solid black' : 'none'" format="png"
                            (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
                            (cropperReady)="cropperReady($event)" (loadImageFailed)="loadImageFailed()">
                        </image-cropper>
                    </div>
                    <div class="ui-g-12">
                        <div *ngIf='croppedImage' class="ui-g-12">
                            Preview
                        </div>
                        <img [src]="croppedImage" [style.border]="croppedImage ? '1px solid black' : 'none'" />
                    </div>
                </ng-container>
                <p-footer>
                    <button pButton type="button" class="ui-button-success" label="Save" icon="pi pi-save"
                        [disabled]="this.signature_file_type_error || this.showCropper==false || this.croppedImage.length==0"
                        (click)="saveSignature()"></button>
                    <button pButton type="button" class="ui-button-warning" label="Cancel" icon="pi pi-times"
                        (click)="close()"></button>
                </p-footer>
            </p-dialog>
        </form>
    </div>
    <div *ngIf="showForm==false">
        <p-dialog header="Profile Update Successful" [(visible)]="display"
            [style]="{'width': '50vw','text-align':'center'}">
            <p>Profile has been updated Successfully</p>
            <p *ngIf="this.changePassword">Password has also been updated Successfully.</p>
            <p *ngIf="this.changePin">Pin has also been updated Successfully.</p>
            <p *ngIf="this.resume_result">Resume has also been updated Successfully.</p>
            <p *ngIf="this.profile_result">Profile photo has also been updated Successfully.</p>
            <p *ngIf="this.sig_result">Signature has also been updated Successfully.</p>
            <p-button label="Go to Dashboard" (click)="gotodashboard()"></p-button>
        </p-dialog>
    </div>

</div>
<div class="row container justify-content-center text-center alert alert-danger"
    *ngIf="response.success!=null && response.success==false">
    <p *ngIf="response.error!=null">{{response.error.message}}</p>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode!=500">
        <p *ngFor="let message of serverError?.message">{{message}}</p>
    </div>
    <div *ngIf="serverError?.error!=null && serverError?.statusCode==500">
        <p>{{serverError?.message}}</p>
    </div>

</div>
<h4 *ngIf="loading">Fetching data...</h4>
<p-progressSpinner [style]="{width: '50px', height: '50px'}" *ngIf="loading" strokeWidth="6">